import React, {useEffect, useState} from 'react';
import {useHistory, useLocation, useParams} from "react-router-dom";
import {useDispatch, useSelector} from 'react-redux';
import {Dropdown, DropdownToggle, DropdownMenu} from 'reactstrap';
import _cloneDeep from 'lodash/cloneDeep';
import _findKey from 'lodash/findKey';
import {sortTypes, searchTypeSorts} from '../../lib/config';
import {createSearchURL} from '../../lib/createSearchURL';
import {updateSearchFilter} from '../../actions';
import styles from './SortBy.scss';
import filterStyles from '../../components/Home/SearchFilter.scss';

const getDefaultSort = (searchType) => {
  return _findKey(sortTypes, (item) => {return item.default && item.default.includes(searchType)})
}

function SortBy(props) {
  let history = useHistory();
  let location = useLocation();
  let params = useParams();
  const dispatch = useDispatch();
  const filterSearch = useSelector(state => state.filterSearch);
  const [sortOpen, setSortOpen] = useState(false);
  const [currentSort, setCurrentSort] = useState(getDefaultSort(params.searchType)); 

  useEffect(() => {
    let newSort = getDefaultSort(params.searchType);
    if (location.search) {
      let sortMatch = location.search.match(/sort=(\w+)/i);
      if (sortMatch) {
        let searchSort = sortMatch[1];
        if (searchTypeSorts[params.searchType].includes(searchSort)) {
          newSort = searchSort;
        } else {
          history.replace(`${location.pathname}?sort=${newSort}`);
        }
      }
    }
    if (newSort != currentSort) {
      setCurrentSort(newSort);
    }
  }, [location, params.searchType]);
  
  const updateSort = (newSort) => {
    setCurrentSort(newSort);
    let newState = _cloneDeep(filterSearch);
    newState.sort = newSort;
    dispatch(updateSearchFilter(newState));

    let searchURL = createSearchURL(newState);
    history.push(searchURL);
  };

  const showSort = () => {
    setSortOpen(!sortOpen);
  }

  const selectSort = (sortType) => {
    setSortOpen(false);
    updateSort(sortType);
  }

  return (
    searchTypeSorts && params.searchType && currentSort ?
      <div className={'mt-sm-2 d-flex align-items-center h-100 ' + styles.sortWrapper}>
        <Dropdown isOpen={sortOpen} toggle={showSort}>
          <DropdownToggle tag="span" className={styles.sortToggle}>
            <strong>Sort by:</strong> {sortTypes[currentSort].label} <span className={sortOpen ? styles.sortClose : styles.sortOpen}></span>
          </DropdownToggle>
          <DropdownMenu className={'p-3 pr-4 ' + filterStyles.dropdownSelected}>
            {searchTypeSorts[params.searchType].map((sortType, index) =>
              <div className={'mb-2 ' + styles.sortTypeList + (sortType == currentSort ? ' ' + styles.active : '')} key={index} onClick={() => selectSort(sortType)}>
                {sortTypes[sortType].label}
              </div>
            )}
          </DropdownMenu>
        </Dropdown>
      </div>
    : null
  );
}

export default SortBy;
